import type { SelectChangeEvent } from '@mui/material';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import type { TeamingType } from 'features/teaming/teaming-base/enums';
import type { SelectItem } from 'features/ui/elements';
import { Select } from 'features/ui/elements';

interface SelectTeamingLocationProps {
  value: TeamingType;
  options: SelectItem[];
  onChange: (event: SelectChangeEvent<TeamingType>) => void;
}

export const SelectTeamingLocation: FC<SelectTeamingLocationProps> = ({
  value,
  options,
  onChange,
  ...props
}) => {
  const { t } = useTranslation('translation', { keyPrefix: 'teamRequest' });

  const handleChange = (event: SelectChangeEvent<unknown>) => {
    onChange(event as SelectChangeEvent<TeamingType>);
  };

  return (
    <Select
      {...props}
      data-testid='select-location'
      placeholder={t('teamingLocationPlaceholder')}
      value={value}
      options={options}
      onChange={handleChange}
    />
  );
};
